<template>
  <div class="spring-festival-chat" @click="isQueryPlayer = false">
    <img src="./images/btn-chat.png" alt="" class="img-header" />

    <div class="spring-festival-main">
      <div class="top" v-if="topComment">
        <img
          :src="topComment.avatarUrl"
          alt=""
          v-if="topComment.avatarUrl && !topComment.isAnonymity"
        />
        <img src="./images/empty.png" alt="" v-else />
        <p class="message">
          {{ formatMessage(topComment.commentDesc) }}
        </p>
      </div>
      <div ref="messageBox" class="message-box">
        <template v-if="commonHistory && commonHistory.length">
          <div
            class="message-item"
            v-for="item of commonHistory"
            :key="item.id"
          >
            <img :src="item.avatarUrl" alt="" v-if="item.avatarUrl" />
            <img src="./images/header-icon.png" alt="" v-else />
            <p class="message">{{ formatMessage(item.description) }}</p>
          </div>
        </template>
        <template v-if="messageList && messageList.length">
          <div class="message-item" v-for="item of messageList" :key="item.id">
            <img
              :src="item.avatar"
              alt=""
              v-if="
                item.avatar && !formatPayloadData(item.payload.data).isAnonymity
              "
            />
            <img src="./images/header-icon.png" alt="" v-else />
            <p class="message">
              {{ item.payload ? formatMessage(item.payload.description) : '' }}
            </p>
          </div>
        </template>
      </div>
      <div class="input-box">
        <div
          class="search-box"
          v-show="isQueryPlayer"
          @click.stop
          v-loading="searchLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <div class="scroll">
            <template
              v-if="
                recentPlayers &&
                  recentPlayers.length &&
                  (!players || !players.length)
              "
            >
              <div class="last-time">最近下單</div>
              <div
                class="search-item"
                v-for="item of recentPlayers"
                :key="item.masterUuid"
                @click="selectPlayer(item)"
              >
                <img
                  :src="item.avatarUrl"
                  alt=""
                  class="search-img-header"
                  v-if="item.avatarUrl"
                />
                <img
                  src="./images/header-icon.png"
                  alt=""
                  class="search-img-header"
                  v-else
                />
                <span>{{ item.nickname }}</span>
              </div>
            </template>

            <div
              class="search-item"
              v-for="item of players"
              :key="item.uuid"
              @click="selectPlayer(item)"
            >
              <img
                :src="item.avatarUrl"
                alt=""
                class="search-img-header"
                v-if="item.avatarUrl"
              />
              <img
                src="./images/header-icon.png"
                alt=""
                class="search-img-header"
                v-else
              />
              <span>{{ item.nickname }}</span>
            </div>
          </div>
          <el-input
            v-model="playerKeyword"
            placeholder="搜索暱稱或uid"
            :maxlength="60"
            prefix-icon="el-icon-search"
            @input="searchPlayer"
          ></el-input>
        </div>
        <div class="left">
          <img
            :src="selectedPlayer.avatarUrl"
            alt=""
            class="input-search-icon"
            @click.stop="isQueryPlayer = true"
            v-if="selectedPlayer && selectedPlayer.avatarUrl"
          />
          <img
            src="./images/header-icon.png"
            alt=""
            class="input-search-icon"
            @click.stop="isQueryPlayer = true"
            v-else
          />
          <el-input
            v-model="message"
            placeholder="發佈彈幕可助力拉票打氣，積累火力值哦~"
            :maxlength="60"
          ></el-input>
        </div>
        <div class="right">
          <button @click="sendBarrage(true)">普通弹幕</button>
          <button @click="sendBarrage()">置顶弹幕</button>
        </div>
      </div>
      <div class="setting-box">
        <div class="left">
          <span>匿名状态发表弹幕</span>
          <button :class="{ 'is-close': !isAnonymity }" @click="setAnonymity()">
            <span>{{ isAnonymity ? '開' : '関' }}</span>
          </button>
        </div>
        <!-- <div class="right">
          <span>自動推送彈幕</span>
          <button :class="{ 'is-close': !isAuto }" @click="setAutoSend()">
            <span>{{ isAuto ? '開' : '関' }}</span>
          </button>
        </div> -->
      </div>
      <!-- 
    <van-button type="primary" @click="sendMessage">主要按钮</van-button>
    <div v-for="(item, index) of messageList" :key="index">
      {{ index }}
    </div> -->
    </div>
  </div>
</template>
<script>
import IM from './im';

import { mapGetters } from 'vuex';

export default {
  name: 'SpringFestivalChat',
  props: {
    stage: {
      typeof: String,
      default: 'NewYear'
    },
    activityData: {
      typeof: Object,
      default: () => {
        return {};
      }
    },
    rankList: {
      typeof: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      // tim: this.IM.tim
      message: '',
      IM,
      isQueryPlayer: false,
      playerKeyword: '',
      selectedPlayer: null,
      isAnonymity: true,
      isAuto: false,
      recentPlayers: [],
      players: [],
      timeout: null,
      commonHistory: [],
      topComment: null,
      searchLoading: false,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    messageList: function() {
      try {
        return [
          ...this.IM.messageObj.springFestivalMessageList
        ];
      } catch (error) {
        return [];
      }
    },
    playerUid: function() {
      try {
        const uid = this.selectedPlayer.masterUuid || this.selectedPlayer.uuid;
        return uid;
      } catch (error) {
        return null;
      }
    },
    // 置頂彈幕是否還在有效期
    topCommentExpiration: function() {
      try {
        return (
          new Date(this.topComment.expirationTime).getTime() >
          new Date().getTime()
        );
      } catch (error) {
        return false;
      }
    },
    lastComment: function() {
      try {
        return this.activityData.appendInfo.lastComment;
      } catch (error) {
        return null;
      }
    },
    // 是否榜单上的用户
    isOrderPlayer() {
      return this.rankList.some(item => {
        return item.userUuid === this.playerUid;
      });
    }
  },
  watch: {
    userInfo: {
      handler: function(val, oVal) {
        if (val && val !== oVal) {
          this.initIm();
        }
      },
      immediate: true
    },
    commonHistory: {
      handler: function(val, oVal) {
        if (val && val !== oVal) {
          this.IM.initSpringFestivalLocalMessage()
        }
      },
      immediate: true
    },
    messageList: {
      handler: function(val, oVal) {
        if (val && val !== oVal) {
          try {
            if (val && val.length) {
              const topComment = [...val].reverse().find(item => {
                return JSON.parse(item.payload.data).isTop;
              });
              if (topComment) {
                this.$emit('refresh');
              }
            }
          } catch (error) {
            console.log(error);
          }
          setTimeout(() => {
            if (this.$refs.messageBox) {
              this.$refs.messageBox.scrollTop = this.$refs.messageBox.scrollHeight;
            }
          }, 1000);
        }
      },
      immediate: true,
      deep: true
    },
    activityData: {
      handler: function(val, oVal) {
        try {
          if (val && val !== oVal) {
            this.commonHistory = [...val.appendInfo.commonHistory].reverse();
            this.topComment = val.appendInfo.topComment;
            this.isAnonymity = val.appendInfo.anonymousSwitch;
            this.isAuto = val.appendInfo.hasAutoComment;
          }
        } catch (error) {
          console.log(error);
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    formatPayloadData(data) {
      if (data === 'anonymity') {
        return {
          isAnonymity: true
        };
      }
      try {
        return JSON.parse(data);
      } catch (error) {
        return {
          isAnonymity: false
        };
      }
    },
    formatMessage(messageString) {
      try {
        const messageDto = JSON.parse(messageString);
        if (messageDto.nickname) {
          return `${messageDto.nickname}為${messageDto.playerName}打氣：${messageDto.message}`;
        } else {
          return messageString;
        }
      } catch (error) {
        return messageString;
      }
    },
    formatTime(msTime) {
      let time = msTime / 1000;
      let hour = Math.floor(time / 60 / 60);
      hour = hour.toString().padStart(2, '0');
      let minute = Math.floor(time / 60) % 60;
      minute = minute.toString().padStart(2, '0');
      let second = Math.floor(time) % 60;
      second = second.toString().padStart(2, '0');
      return `${hour}小时${minute}分钟${second}秒`;
    },
    async initIm() {
      try {
        await this.IM.imLogin(this.userInfo);
        await this.IM.IM_READY;
        await this.IM.joinGroup();
        // await this.IM.barrageImGroupDto.joinGroup();
      } catch (error) {
        console.log(error);
      }
    },
    async sendMessage(isTop) {
      const data = {
        isAnonymity: this.isAnonymity
      };
      if (isTop) {
        data['isTop'] = true;
      }
      const desc = {
        nickname: this.isAnonymity ? '神秘老闆' : this.userInfo.nickname, //显示的用户姓名
        playerName: this.selectedPlayer.nickname, //玩家姓名
        message: this.message, //发送的消息
        userName: this.userInfo.nickname // 用户的真实姓名
      };
      const payload = {
        data: JSON.stringify(data),
        description: JSON.stringify(desc)
      };
      try {
        await this.IM.sendMessage(payload);
        this.IM.addSpringFestivalLocalMessage({
          avatar: this.userInfo.avatarUrl,
          payload: payload,
          nick: this.userInfo.nickname
        });
        return;
      } catch (error) {
        console.log('error', error);
      }
    },

    // 選擇陪玩師
    selectPlayer(player) {
      this.selectedPlayer = player;
      this.isQueryPlayer = false;
    },

    //設置制動發送
    setAutoSend() {
      if (this.isAuto) {
        this.$confirm({
          message: `是否關閉自動推送彈幕`,
          title: '提示',
          showCancelButton: true,
          confirmButtonText: '確定',
          closeOnClickOverlay: false,
          className: 'spring-festival-dialog-bg'
        }).then(() => {
          this.closeAutoSend();
        });
      } else {
        if (!this.lastComment || !this.lastComment.id) {
          this.$confirm({
            message: `您當前未有發表過彈幕，請先發佈一條彈幕后再進行重試`,
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: true,
            className: 'spring-festival-dialog-bg'
          });
          return;
        }
        this.$confirm({
          message: `您是否想要開啓自動發佈彈幕功能？（沒隔2分鈡會自動推送上一條彈幕所發佈過的内容，並從賬戶餘額上扣除2nicee幣）`,
          title: '提示',
          showCancelButton: true,
          confirmButtonText: '確定',
          closeOnClickOverlay: false,
          className: 'spring-festival-dialog-bg'
        }).then(() => {
          let descDto = {};
          try {
            descDto = JSON.parse(this.lastComment.description);
          } catch (error) {
            console.log(error);
          }
          this.$confirm({
            message: `點擊“確定”后將自動為陪玩師${descDto.playerName}加油打氣，您的打氣彈幕内容為：${descDto.message}`,
            title: '提示',
            showCancelButton: true,
            confirmButtonText: '確定',
            closeOnClickOverlay: false,
            className: 'spring-festival-dialog-bg'
          }).then(() => {
            this.openAutoSend();
          });
        });
      }
    },
    sendBarrage(isCommom) {
      if (!this.playerUid) {
        this.$confirm({
          message: `請點擊輸入框左側頭像框，選擇對應陪玩師后再進行發表彈幕`,
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        });
        return;
      }
      if (!this.message) {
        this.$message('不能發送空白消息');
        return;
      }
      if (isCommom) {
        this.sendCommonBarrage();
      } else {
        this.sendTopBarrage();
      }
    },
    sendCommonBarrage() {
      this.$confirm({
        message: `您是否想要花費2nicee幣以${
          this.isAnonymity ? '匿名' : '公開'
        }身份的狀態為陪玩師(${this.selectedPlayer.nickname})加油打氣？`,
        title: '提示',
        showCancelButton: true,
        confirmButtonText: '確定',
        closeOnClickOverlay: false,
        className: 'spring-festival-dialog-bg'
      }).then(() => {
        const desc = {
          nickname: this.isAnonymity ? '神秘老闆' : this.userInfo.nickname,
          playerName: this.selectedPlayer.nickname,
          message: this.message,
          userName: this.userInfo.nickname
        };
        this.$http
          .post('/activity/prop/buy', {
            desc: JSON.stringify(desc),
            toPlayerUuid: this.playerUid,
            dictType: this.stage,
            propType: 'COMMENT'
          })
          .then(async () => {
            await this.sendMessage();
            this.message = '';
            this.$confirm({
              message: `彈幕發送成功`,
              title: '提示',
              showCancelButton: false,
              confirmButtonText: '確定',
              closeOnClickOverlay: true,
              className: 'spring-festival-dialog-bg'
            });
            this.$emit('refresh');
          })
          .catch(error => {
            if (error && error.msg) {
              this.$message(error.msg);
            }
          });
      });
    },
    sendTopBarrage() {
      let price = 500;
      let unLockTime = null;
      let integral = 1520;
      let message = '';
      if (this.topComment) {
        price = this.topComment.price || 500;
        unLockTime = this.topComment.unLockTime;
      }
      if (unLockTime && new Date(unLockTime).getTime() > new Date().getTime()) {
        this.$confirm({
          message: `當前置頂彈幕仍處於5分鐘保護期，請稍後重試`,
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        });
        return;
      }
      if (this.topCommentExpiration) {
        price = price + 100;
        integral = integral + parseInt((price - 500) / 100) * 200;
        message = `當前上一條置頂彈幕剩餘展示時間為${this.formatTime(
          new Date(this.topComment.expirationTime).getTime() -
            new Date().getTime()
        )}，是否確認花費${price}nicee幣以${
          this.isAnonymity ? '匿名' : '公開'
        }身份的狀態為陪玩師(${this.selectedPlayer.nickname})加油打氣？${
          this.isOrderPlayer ? '(可為陪玩師增加' + integral + '火力值)' : ''
        }`;
      } else {
        message = `您是否想要花費500nicee幣以${
          this.isAnonymity ? '匿名' : '公開'
        }身份的狀態為陪玩師(${this.selectedPlayer.nickname})加油打氣？${
          this.isOrderPlayer ? '(可為陪玩師增加' + integral + '火力值)' : ''
        }`;
      }
      this.$confirm({
        message: message,
        title: '提示',
        showCancelButton: true,
        confirmButtonText: '確定',
        closeOnClickOverlay: false,
        className: 'spring-festival-dialog-bg size-mini'
      }).then(() => {
        const desc = {
          nickname: this.isAnonymity ? '神秘老闆' : this.userInfo.nickname,
          playerName: this.selectedPlayer.nickname,
          message: this.message,
          userName: this.userInfo.nickname
        };
        this.$http
          .post('/activity/prop/buy', {
            desc: JSON.stringify(desc),
            toPlayerUuid: this.playerUid,
            dictType: this.stage,
            propType: 'TOP_COMMENT'
          })
          .then(async () => {
            await this.sendMessage(true);
            this.message = '';
            this.$confirm({
              message: `搶占置頂位置成功！置頂彈幕有效時間為6個小時，即刻開始生效；5分鐘内為無敵時間其他用戶無法搶占您的置頂位置`,
              title: '提示',
              showCancelButton: false,
              confirmButtonText: '確定',
              closeOnClickOverlay: true,
              className: 'spring-festival-dialog-bg'
            });
            this.$emit('refresh');
          })
          .catch(error => {
            if (error && error.msg) {
              this.$message(error.msg);
            }
          });
      });
    },
    // 获取最近下单的陪玩师
    getRecentPlayer() {
      this.$http.get('/user/recent/master').then(({ data }) => {
        this.recentPlayers = data || [];
      });
    },
    // 查找陪玩师
    searchPlayer() {
      if (this.timeout) {
        this.searchLoading = false;
        clearTimeout(this.timeout);
      }
      if (!this.playerKeyword) {
        this.players = [];
        this.searchLoading = false;
        return;
      }
      this.timeout = setTimeout(() => {
        this.searchLoading = true;
        this.$http
          .get('/user/search', { searchKey: this.playerKeyword })
          .then(({ data }) => {
            this.players = data || [];
          })
          .finally(() => {
            this.searchLoading = false;
          });
      }, 1500);
    },
    // 关闭自动发送弹幕
    closeAutoSend() {
      this.$http
        .post('/activity/prop/buy', {
          dictType: this.stage,
          isCancel: true
        })
        .then(() => {
          this.isAuto = false;
          this.$confirm({
            message: `關閉自動推送彈幕成功`,
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: true,
            className: 'spring-festival-dialog-bg'
          });
        })
        .catch(error => {
          if (error && error.msg) {
            this.$message(error.msg);
          }
        });
    },
    // 開啓自動發送彈幕
    openAutoSend() {
      this.$http
        .post('/activity/prop/buy', {
          dictType: this.stage,
          propType: 'TIMING_COMMENT'
        })
        .then(() => {
          this.isAuto = true;
          this.$confirm({
            message: `自動推送彈幕開啓成功`,
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: true,
            className: 'spring-festival-dialog-bg'
          });
        })
        .catch(error => {
          if (error && error.msg) {
            this.$message(error.msg);
          }
        });
    },
    // 設置匿名
    setAnonymity() {
      this.$confirm({
        message: `是否${this.isAnonymity ? '關閉' : '開啓'}匿名狀態發表彈幕`,
        title: '提示',
        showCancelButton: false,
        confirmButtonText: '確定',
        closeOnClickOverlay: true,
        className: 'spring-festival-dialog-bg'
      }).then(() => {
        this.$http
          .post('/activity/prop/buy', {
            dictType: this.stage,
            propType: 'ANONYMOUS',
            desc: ''
          })
          .then(() => {
            this.isAnonymity = !this.isAnonymity;
            this.$message(
              `已${this.isAnonymity ? '開啓' : '關閉'}匿名狀態發表彈幕`
            );
          })
          .catch(error => {
            if (error && error.msg) {
              this.$message(error.msg);
            }
          });
      });
    }
  },
  created() {
    this.getRecentPlayer();
    // this.initIm();
  }
};
</script>
<style lang="scss" scoped>
.spring-festival-chat {
  position: relative;
  .img-header {
    width: 27.92rem;
    height: 6.92rem;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, -50%);
  }

  .spring-festival-main {
    width: 100rem;
    border: 1px solid #a97f49;
    border-radius: 24px;
    margin-top: 9.08rem;
    overflow: hidden;
    .message-box {
      height: 33rem;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .message-item,
    .top {
      margin: 0 4rem;
      display: flex;
      align-items: center;

      img {
        object-fit: cover;
        width: 5.75rem;
        height: 5.75rem;
        border-radius: 50%;
        margin-right: 1.58rem;
      }
    }
    .top {
      height: 10.25rem;
      color: #ffffff;
      font-size: 1.83rem;
      margin-top: 4.67rem;
      background: url('./images/chat-top.png') no-repeat center top;
      background-size: 100% 100%;
      padding: 0 0.58rem;
    }
    .message-item {
      color: #e9cc95;
      font-size: 1.5rem;
      min-height: 8.4rem;
    }
    .input-box {
      height: 8rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #e0b675;
      border-bottom: 1px solid #e0b675;
      background-color: #855534;
      padding: 0 4rem 0;
      margin-top: 3rem;

      position: relative;
      .search-box {
        position: absolute;
        top: -2px;
        left: 4rem;
        transform: translateY(-100%);
        max-width: 50rem;
        background-color: #7d4925;
        padding: 1rem;
        font-size: 1.5rem;
        color: #ffe9c7;
        .scroll {
          max-height: 29rem;
          min-height: 25rem;
          overflow: auto;
        }

        .last-time {
          text-align: center;
          padding: 2rem 1rem 1rem;
        }

        .search-item {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          height: 5rem;
          .search-img-header {
            width: 3.58rem;
            height: 3.58rem;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 2rem;
          }
        }
        /deep/ .el-icon-search {
          color: #ffe9c7;
          margin-top: 0.3rem;
        }
        /deep/ .el-input__inner {
          background-color: inherit;
          border: 1px solid #ffe9c7;
          flex: auto;
          color: #ffe9c7;
          padding: 1rem 1rem 1rem 6rem;
          border-radius: 4rem;
          height: 5rem;
          &::-webkit-input-placeholder {
            font-size: 1.5rem;
            color: #ffe9c7;
          }
        }
      }
      .left,
      .right {
        display: flex;
        align-items: center;
        .input-search-icon {
          width: 4rem;
          height: 4rem;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 2rem;
        }
        .input-imoji {
          width: 24px;
          height: 24px;
        }
        /deep/ .el-input__inner {
          background-color: inherit;
          border: none;
          flex: auto;
          color: #ffe9c7;
          padding: 0;
          &::-webkit-input-placeholder {
            font-size: 1.5rem;
            color: #ffe9c7;
          }
        }
      }
      .left {
        flex: auto;
      }
      .right {
        button {
          background-color: #ffe9a4;
          border-radius: 50px;
          color: #914300;
          padding: 1rem 2rem;
          &:first-of-type {
            margin-right: 7px;
          }
        }
      }
    }
    .setting-box {
      height: 8rem;
      display: flex;
      align-items: center;
      color: #ffe9c7;
      font-size: 1.5rem;
      background-color: #744423;
      .left {
        border-right: 1px solid #e0b675;
      }
      .left,
      .right {
        width: 1px;
        flex: auto;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
      button {
        width: 8.08rem;
        // height: 26px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background-color: #ffe38b;
        padding: 0.1rem 0.4rem;
        border-radius: 20px;
        span {
          display: inline-block;
          // width: 16px;
          // height: 16px;
          // line-height: 16px;
          border-radius: 50%;
          color: #ffffff;
          text-align: center;
          background-color: #743805;
          padding: 4px;
        }
        &.is-close {
          background-color: #d2d2d2;
          span {
            background-color: #5f4a3b;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
